import React, { useState } from 'react';
import Pagination from 'react-js-pagination';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import constant from '../../constant';
import Loader from '../common/Loader';
import queryString from 'query-string';

export default function ListCampusDrive(props) {

    const {
        list,
        count,
        showLoader,
        setPage,
        updateStatus,
        keyword,
        statusFilter,
        searchList
    } = props;

    const location = useLocation();
    const navigate = useNavigate();
    const qParams = queryString.parse(location.search);

    const [currentPage, setCurrentPage] = useState(qParams?.p ? Number(qParams.p) : 1);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        navigate(location.pathname + '?p=' + pageNumber);
        setPage(pageNumber);
    };

    const updateDriveStatus = (DRIVE_ID, STATUS) => {
        updateStatus({
            DRIVE_ID,
            STATUS
        });
        setPage(currentPage);
    };

    return (
        <React.Fragment>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">

                        {/* Page Title */}
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0">Campus Drive List</h4>
                                </div>
                            </div>
                        </div>

                        {/* 🔍 FILTER BAR (Like IndustryList) */}
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <form className="row gy-2 gx-2 align-items-center">

                                            <div className="col-sm-5">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search Drive Name / College"
                                                    onChange={(e) => keyword(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-sm-3">
                                                <select
                                                    className="form-control"
                                                    onChange={(e) => statusFilter(e.target.value)}
                                                >
                                                    <option value="">All Status</option>
                                                    <option value="PUBLISHED">Published</option>
                                                    <option value="ONGOING">Ongoing</option>
                                                    <option value="COMPLETED">Completed</option>
                                                    <option value="CANCELLED">Cancelled</option>
                                                </select>
                                            </div>

                                            <div className="col-sm-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-success w-100"
                                                    onClick={() => {
                                                        setCurrentPage(1);
                                                        searchList();
                                                    }}
                                                >
                                                    Search
                                                </button>
                                            </div>

                                            <div className="col-sm-2">
                                                <a
                                                    type="button"
                                                    href={constant.component.addCampusDrive.url}
                                                    className="btn btn-primary"
                                                >
                                                    Create Drive
                                                </a>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* LIST TABLE */}
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">

                                        <div className="table-responsive">
                                            <table className="table align-middle table-nowrap table-hover">

                                                {showLoader && <Loader />}

                                                {!showLoader &&
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>Drive Code</th>
                                                            <th>Drive</th>
                                                            <th>College</th>
                                                            <th>Schedule</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                }

                                                <tbody>
                                                    {list && list.length > 0 &&
                                                        list.map((item) => (
                                                            <tr key={item.ID}>
                                                                <td className="text-warning">
                                                                    {item.DRIVE_CODE || `CD-${item.ID}`}
                                                                </td>

                                                                <td>
                                                                    <strong>{item.DRIVE_NAME}</strong>
                                                                    <p className="text-muted mb-0">
                                                                        {moment(item.CREATED_AT).format('DD-MM-YYYY')}
                                                                    </p>
                                                                </td>

                                                                <td>
                                                                    {item.COLLEGE_NAME}
                                                                    <p className="text-muted mb-0">
                                                                        {item.COLLEGE_CITY}, {item.COLLEGE_STATE}
                                                                    </p>
                                                                </td>

                                                                <td>
                                                                    {moment(item.DRIVE_DATE).format('DD-MM-YYYY')}
                                                                    <br />
                                                                    <small>{item.DRIVE_START_TIME} - {item.DRIVE_END_TIME}</small>
                                                                </td>

                                                                <td>
                                                                    <span className={`badge rounded-pill 
                                                                        ${item.DRIVE_STATUS === 'PUBLISHED' ? 'bg-primary' :
                                                                            item.DRIVE_STATUS === 'ONGOING' ? 'bg-warning' :
                                                                                item.DRIVE_STATUS === 'COMPLETED' ? 'bg-success' :
                                                                                    'bg-danger'}`}>
                                                                        {item.DRIVE_STATUS}
                                                                    </span>
                                                                </td>

                                                                <td>
                                                                    <ul className="list-inline mb-0">

                                                                        <li className="list-inline-item">
                                                                            <Link
                                                                                to={constant.component.viewCampusDrive.url.replace(':id', item.ID)}
                                                                                title="View">
                                                                                <i className="bx bx-show"></i>
                                                                            </Link>
                                                                        </li>

                                                                        <li className="list-inline-item">
                                                                            <Link
                                                                                to={constant.component.editCampusDrive.url.replace(':id', item.ID)}
                                                                                title="Edit">
                                                                                <i className="bx bx-edit"></i>
                                                                            </Link>
                                                                        </li>

                                                                        <li className="list-inline-item">
                                                                            <a
                                                                                href="javascript:void(0)"
                                                                                title="Change Status"
                                                                                onClick={() =>
                                                                                    updateDriveStatus(
                                                                                        item.ID,
                                                                                        item.DRIVE_STATUS === 'CANCELLED'
                                                                                            ? 'PUBLISHED'
                                                                                            : 'CANCELLED'
                                                                                    )
                                                                                }
                                                                            >
                                                                                {item.DRIVE_STATUS === 'CANCELLED'
                                                                                    ? <i className="bx bx-check-circle text-success"></i>
                                                                                    : <i className="bx bx-x-circle text-danger"></i>}
                                                                            </a>
                                                                        </li>

                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }

                                                    {!showLoader && list.length === 0 &&
                                                        <tr>
                                                            <td colSpan="6" className="text-center text-danger">
                                                                No Campus Drive Found
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* PAGINATION */}
                                        <div className="pagination pagination-rounded justify-content-center mt-4">
                                            <Pagination
                                                activePage={currentPage}
                                                itemsCountPerPage={10}
                                                totalItemsCount={count}
                                                pageRangeDisplayed={5}
                                                onChange={handlePageChange}
                                                itemClass="page-item"
                                                linkClass="page-link"
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
